<span class="m-plus"
      :class="[ 'm--is-skin-' + skin, {
                'm--is-open': open,
                'm--is-disabled': disabled,
                'm--is-large': large,
                'm--has-border': border }]"
      :title="title"
      @click="onClick"></span>
